const subscriptionPriceId = (key) => process.env[`VUE_APP_SUBSCRIPTION_${key}_PRICE_ID`] || '';

export default [
    {
        name: 'Free',
        period: 'month',
        price_id: '',
        price: 0
    },
    {
        name: 'Starter',
        period: 'month',
        price_id: subscriptionPriceId('STARTER_MONTH'),
        price: 5
    },
    {
        name: 'Starter',
        period: 'quarter',
        price_id: subscriptionPriceId('STARTER_QUARTER'),
        price: 13.5
    },
    {
        name: 'Starter',
        period: 'year',
        price_id: subscriptionPriceId('STARTER_YEAR'),
        price: 48
    },
    {
        name: 'Creator',
        period: 'month',
        price_id: subscriptionPriceId('CREATOR_MONTH'),
        price: 15,
    },
    {
        name: 'Creator',
        period: 'quarter',
        price_id: subscriptionPriceId('CREATOR_QUARTER'),
        price: 40.5,
    },
    {
        name: 'Creator',
        period: 'year',
        price_id: subscriptionPriceId('CREATOR_YEAR'),
        price: 144,
    },
    {
        name: 'Standard',
        period: 'month',
        price_id: subscriptionPriceId('STANDARD_MONTH'),
        price: 24,
    },
    {
        name: 'Standard',
        period: 'quarter',
        price_id: subscriptionPriceId('STANDARD_QUARTER'),
        price: 64.8,
    },
    {
        name: 'Standard',
        period: 'year',
        price_id: subscriptionPriceId('STANDARD_YEAR'),
        price: 230.4,
    },
    {
        name: 'Pro',
        period: 'month',
        price_id: subscriptionPriceId('PRO_MONTH'),
        price: 79,
    },
    {
        name: 'Pro',
        period: 'quarter',
        price_id: subscriptionPriceId('PRO_QUARTER'),
        price: 213.3,
    },
    {
        name: 'Pro',
        period: 'year',
        price_id: subscriptionPriceId('PRO_YEAR'),
        price: 758.4,
    },
]
